import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function CellCultivation() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/d2ed86b74e50b771b9e10842f266a0b2.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">細胞の培養</h1>
          <p className="text-lg md:text-xl mb-8 opacity-95">
            自動化技術と専門技術者の育成で、高品質な細胞培養を実現
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
              細胞培養サービス
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Exosome Oneは、細胞加工認可を取得した自社施設で、
              幹細胞の大量培養から技術者育成まで包括的なサービスを提供しています。
            </p>
          </div>

          {/* Core Services */}
          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-flask-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">委託培養サービス</h3>
              <ul className="space-y-3 text-sm text-gray-700 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>幹細胞の大量培養</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>細胞株の維持・管理</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>品質管理・検査</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>カスタム培養プロトコール</span>
                </li>
              </ul>
              <div className="text-center">
                <span className="inline-block bg-teal-100 text-teal-800 text-xs px-3 py-1 rounded-full font-medium">
                  医療機関対応
                </span>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-robot-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">自動培養システム</h3>
              <ul className="space-y-3 text-sm text-gray-700 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>完全自動化ロボット導入</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>24時間無人運転</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>品質の均一化</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>コスト削減効果</span>
                </li>
              </ul>
              <div className="text-center">
                <span className="inline-block bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full font-medium">
                  革新技術
                </span>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-graduation-cap-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">技術者育成支援</h3>
              <ul className="space-y-3 text-sm text-gray-700 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>培養士の育成プログラム</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>実技指導・研修</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>技術認定・資格支援</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>継続的な技術サポート</span>
                </li>
              </ul>
              <div className="text-center">
                <span className="inline-block bg-purple-100 text-purple-800 text-xs px-3 py-1 rounded-full font-medium">
                  人材育成
                </span>
              </div>
            </div>
          </div>

          {/* Cultivation Process */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center text-gray-800">培養プロセス</h3>
            
            <div className="grid md:grid-cols-5 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">細胞受入</h4>
                <p className="text-sm text-gray-600">
                  厳格な品質検査とウイルス検査を実施
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">培養開始</h4>
                <p className="text-sm text-gray-600">
                  最適化された培地で細胞培養を開始
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">品質監視</h4>
                <p className="text-sm text-gray-600">
                  AI技術による24時間品質モニタリング
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">大量培養</h4>
                <p className="text-sm text-gray-600">
                  自動化システムによる効率的な大量培養
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">5</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">出荷準備</h4>
                <p className="text-sm text-gray-600">
                  最終検査と適切な保存・輸送体制
                </p>
              </div>
            </div>
          </div>

          {/* Facilities & Equipment */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">施設・設備</h3>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-building-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">認可取得施設</h4>
                    <p className="text-sm text-gray-600">
                      細胞加工施設としての認可を取得した最先端のクリーンルーム環境で、
                      医療グレードの細胞培養を行います。
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                    <i className="ri-robot-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">自動培養ロボット</h4>
                    <p className="text-sm text-gray-600">
                      独自開発の完全自動培養ロボットにより、人的ミスを排除し、
                      品質の均一化と生産効率の向上を実現しています。
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                    <i className="ri-microscope-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2 text-gray-800">高精度分析機器</h4>
                    <p className="text-sm text-gray-600">
                      最新の分析装置により、細胞の品質・純度・活性を
                      リアルタイムで監視・評価します。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=State-of-the-art%20cell%20cultivation%20facility%20with%20automated%20robotic%20systems%20and%20clean%20room%20environment%2C%20modern%20biotechnology%20laboratory%20with%20sophisticated%20bioreactors%20and%20cell%20culture%20incubators%2C%20sterile%20manufacturing%20facility%20with%20blue%20LED%20lighting%20and%20temperature%20controlled%20systems%2C%20advanced%20cell%20processing%20equipment%20with%20microscopes%20and%20analysis%20instruments%2C%20futuristic%20medical%20laboratory%20showcasing%20automated%20cell%20cultivation%20technology&width=600&height=400&seq=cell-cultivation-facility-2024&orientation=landscape"
                alt="培養施設"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>

          {/* Quality Assurance */}
          <div className="bg-gradient-to-br from-teal-600 to-blue-600 text-white rounded-2xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center">品質保証体制</h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <i className="ri-shield-check-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">無菌環境</h4>
                <p className="text-sm opacity-90">クラス10000のクリーンルーム</p>
              </div>
              <div className="text-center">
                <i className="ri-virus-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">ウイルス検査</h4>
                <p className="text-sm opacity-90">厳格なウイルス・細菌検査</p>
              </div>
              <div className="text-center">
                <i className="ri-file-chart-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">品質データ</h4>
                <p className="text-sm opacity-90">培養過程の完全記録・追跡</p>
              </div>
              <div className="text-center">
                <i className="ri-award-line text-4xl mb-4 opacity-90"></i>
                <h4 className="font-bold mb-2">認証取得</h4>
                <p className="text-sm opacity-90">GMP準拠の管理体制</p>
              </div>
            </div>
          </div>

          {/* Training Program */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20cell%20culture%20training%20program%20with%20scientists%20teaching%20laboratory%20techniques%2C%20medical%20professionals%20learning%20stem%20cell%20cultivation%20methods%2C%20modern%20biotechnology%20training%20facility%20with%20hands-on%20cell%20culture%20instruction%2C%20educational%20laboratory%20environment%20with%20microscopes%20and%20cell%20culture%20equipment%2C%20expert%20instructors%20guiding%20trainees%20in%20sterile%20cell%20handling%20procedures&width=600&height=400&seq=cell-culture-training-2024&orientation=landscape"
                alt="技術者育成プログラム"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">技術者育成プログラム</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm flex-shrink-0">1</span>
                  <div>
                    <h4 className="font-bold mb-1 text-gray-800">基礎理論学習</h4>
                    <p className="text-sm text-gray-600">細胞生物学・培養技術の基礎知識</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm flex-shrink-0">2</span>
                  <div>
                    <h4 className="font-bold mb-1 text-gray-800">実技研修</h4>
                    <p className="text-sm text-gray-600">実際の培養操作・機器操作の習得</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm flex-shrink-0">3</span>
                  <div>
                    <h4 className="font-bold mb-1 text-gray-800">品質管理</h4>
                    <p className="text-sm text-gray-600">検査方法・品質評価の技術習得</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-teal-600 text-white rounded-full font-bold text-sm flex-shrink-0">4</span>
                  <div>
                    <h4 className="font-bold mb-1 text-gray-800">認定試験</h4>
                    <p className="text-sm text-gray-600">技術レベルの認定・資格付与</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-700">
                  <strong>研修期間：</strong>3ヶ月～6ヶ月<br />
                  <strong>対象：</strong>医療従事者・研究者・技術者<br />
                  <strong>認定：</strong>Exosome One認定培養士資格付与
                </p>
              </div>
            </div>
          </div>

          {/* Advantages */}
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-6 text-gray-800">Exosome Oneの細胞培養サービスの特徴</h3>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-speed-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">高効率</h4>
                <p className="text-sm text-gray-600">
                  自動化技術により従来比3倍の効率で高品質な細胞培養を実現
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-shield-star-line text-3xl text-blue-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">高品質</h4>
                <p className="text-sm text-gray-600">
                  医療グレードの品質管理体制で安全性と有効性を保証
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-team-line text-3xl text-purple-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">専門性</h4>
                <p className="text-sm text-gray-600">
                  豊富な経験と専門知識を持つ技術者による包括的サポート
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}